

<template>
  <div class="signup app-content bg-gray">
    <div class="bg-blue pb-5">
      <div class="container bg-blue">
        <div class="row mx-0 pb-2">
          <div class="col-12 p-0">
            <router-link :to="'/job_mypage'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
            </router-link>
            <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
            <a>
              <p class="text-dark font14 under" style="display: inline;">求人情報</p>
            </a>
          </div>
        </div>
        <div class="row pt-4 mb-2">
          <div class="col-12">
            <router-link :to="'/jobs'">
              <p class="pt-3">＜ 前に戻る</p>
            </router-link>
          </div>
        </div>
      </div>
      <div class="container px-5">
        <div class="row pt-4 mb-2 px-5 mx-3">
          <div class="col-12 p-5 bg-white">
              <b-row class='mt-2 border-orange px-5 py-2'>
                <b-col cols='12' class=' pb-2'>
                  <h4> {{ jobInfo.title }} </h4>
                  <!--
                  {{ companyInfo.name }} - {{ companyInfo.address1 }} {{ companyInfo.address2 }}<br>
                  ￥{{ min_salary }} 〜 ￥{{ max_salary }} ( {{ salaryOptions[jobInfo.employment_form] }}) -->
                </b-col>
                <b-col cols='12' class=' mt-3'>
                  <label >● 業種 </label><br>
                  <label >{{ INDUSTRY_DICTIONARY[jobInfo.industry] }} </label><br>

                  <label >● 職種 </label><br>
                  <label >{{ jobInfo.occupation }} </label><br>

                  <label >● 給与 </label><br>
                  <label >{{ salaryOptions[jobInfo.employment_form] }} {{ jobInfo.salary_from }}万円 〜 {{ jobInfo.salary_to }}万円 </label><br>

                  <label >● 勤務時間 </label><br>
                  <label >{{ jobInfo.working_hours }}</label><br>

                  <label >● 勤務地 </label><br>
                  <label >{{ jobInfo.location }} </label><br>

                  <label >● 仕事内容及びアピールポイント </label><br>
                  <label >{{ jobInfo.description }} </label><br>

                  <label >● 応募資格 </label><br>
                  <label >{{ jobInfo.qualification }} </label><br>

                  <label >● 求める人材 </label><br>
                  <label >{{ jobInfo.human_resource }}</label><br>

                  <label >● 採用人数 </label><br>
                  <label >{{ jobInfo.number_of_hires }}人 </label><br>

                  <label >● 独身者・既婚者・不問 </label><br>
                  <label >{{ MARRIEDLIST[jobInfo.married_type] }} </label><br>

                  <label >● 日本語レベル </label><br>
                  <label >{{ JAPANESELIST[jobInfo.japanese_level] }}</label><br>

                  <label >● 希望国籍 </label><br>
                  <label >{{ HOPELIST[jobInfo.hope_of_country] }}</label><br>

                  <label >● 学歴 </label><br>
                  <label >{{ EDUCARIONALLIST[jobInfo.educational_background] }} </label><br>

                  <label >● 国外からの応募可否 </label><br>
                  <label >{{ OVERSEASLIST[jobInfo.apply_from_overseas] }} </label><br>

                  <label >● 休憩時間 </label><br>
                  <label >{{ jobInfo.break_time }} </label><br>

                  <label >● 月残業時間 </label><br>
                  <label >{{ jobInfo.overtime }}</label><br>

                  <label >● 休日 </label><br>
                  <label >{{ BREAKTIMELIST[jobInfo.holiday] }}</label><br>

                  <label >● 労務管理 </label><br>
                  <label >{{ jobInfo.labor_management }}</label><br>

                  <label >● 賃金台帳 </label><br>
                  <label >{{ jobInfo.wage_ledger }}</label><br>

                  <label >● 出勤簿 </label><br>
                  <label >{{ jobInfo.attendance_record }} </label><br>

                  <label >● 賃金台帳作成担当者 </label><br>
                  <label >{{ jobInfo.wage_ledger_creator }} </label><br>

                  <label >● 賃金台帳作成方法 </label><br>
                  <label >{{ WAGELIST[jobInfo.way_create_wage_ledger] }} </label><br>

                  <label >● 就労時間管理 </label><br>
                  <label >{{ TIMEMANAGEMENTLIST[jobInfo.working_time_management] }}</label><br>

                  <label >● 食事関係 </label><br>
                  <label >{{ MEALLIST[jobInfo.meal_related] }} (毎月の徴収費用 {{ jobInfo.facilities_equipment }})</label><br>

                  <label >● 作業着 </label><br>
                  <label >{{ WORKCLOTHLIST[jobInfo.work_clothes] }} </label><br>

                  <label >● 保護具 </label><br>
                  <label >{{ WORKCLOTHLIST[jobInfo.protective_equipment] }} </label><br>

                  <label >● 宿泊施設概要 </label><br>
                  <label >{{ jobInfo.accommodation_overview }} </label><br>

                  <label >● 宿泊施設場所 </label><br>
                  <label >{{ PLACELIST[jobInfo.place] }}</label><br>

                  <label >● 宿泊施設名 </label><br>
                  <label >{{ jobInfo.accommodation_name }}</label><br>

                  <label >● 宿泊施設所在地 </label><br>
                  <label >{{ jobInfo.accommodation_location }}</label><br>

                  <label >● 部屋面積 </label><br>
                  <label >{{ jobInfo.room }} m<sup>2</sup></label><br>

                  <label >● 部屋収容人数 </label><br>
                  <label >{{ room_capacity }} 名</label><br>

                  <label >● 一人当たりの居室 </label><br>
                  <label >{{ room_per_person }} </label><br>

                  <label >● 徴収費用 住居費 </label><br>
                  <label >月額{{ living_cost }}円</label><br>

                  <label >● 徴収費用 水道光熱費 </label><br>
                  <label >{{ CollectionFeeDict[jobInfo.utility_cost] }}</label><br>

                  <label >● 徴収費用 通信費 </label><br>
                  <label >{{ CollectionFeeDict[jobInfo.communication_cost]  }}</label><br>

                  <label >● 交通アクセス(宿泊施設から職場までの所要時間) </label><br>
                  <label >{{ access_minute }}分</label><br>

                  <label >● 交通アクセス(方法) </label><br>
                  <label >{{ access_way }}</label><br>

                  <label >● 引っ越し代の負担 </label><br>
                  <label >{{ MOVINGLIST[jobInfo.moving_fee] }}</label><br>

                  <label >● 待遇・福利厚生 </label><br>
                  <label >{{ jobInfo.walfare }} 名</label><br>

                  <label >● その他 </label><br>
                  <label >{{ jobInfo.other }} </label><br>

                  <label >● 働き方紹介画像 </label><br>
                  <b-row>
                    <b-col cols='5' class='pr-4' v-for='(image, index) in split(jobInfo.images)' :key='index'>
                      <img :src="image" class="w100">
                    </b-col>
                  </b-row>

                  <label >● 募集背景 </label><br>
                  <label >{{ jobInfo.background }}</label><br>

                  <label >● 入社後の流れ </label><br>
                  <label >{{ jobInfo.after_joining }}</label><br>

                  <label >● 会社外写真 </label><br>
                  <b-row>
                    <b-col cols='5' class='pr-4' v-for='(image, index) in split(jobInfo.outside_office_image)' :key='index'>
                      <img :src="image" class="w100">
                    </b-col>
                  </b-row>

                  <label >● 会社内写真 </label><br>
                  <b-row>
                    <b-col cols='5' class='pr-4' v-for='(image, index) in split(jobInfo.within_office_image)' :key='index'>
                      <img :src="image" class="w100">
                    </b-col>
                  </b-row>

                  <label >● 該当仕事写真 </label><br>
                  <b-row>
                    <b-col cols='5' class='pr-4' v-for='(image, index) in split(jobInfo.working_image)' :key='index'>
                      <img :src="image" class="w100">
                    </b-col>
                  </b-row>

                  <label >● 社員写真 </label><br>
                  <b-row>
                    <b-col cols='5' class='pr-4' v-for='(image, index) in split(jobInfo.employee_image)' :key='index'>
                      <img :src="image" class="w100">
                    </b-col>
                  </b-row>

                  <label >● 寮部屋外写真 </label><br>
                  <b-row>
                    <b-col cols='5' class='pr-4' v-for='(image, index) in split(jobInfo.outside_dormitory_image)' :key='index'>
                      <img :src="image" class="w100">
                    </b-col>
                  </b-row>

                  <label >● 寮部屋内写真 </label><br>
                  <b-row>
                    <b-col cols='5' class='pr-4' v-for='(image, index) in split(jobInfo.within_dormitory_image)' :key='index'>
                      <img :src="image" class="w100">
                    </b-col>
                  </b-row>

                  <div v-if="is_other_conditions" >
                    <label >● その他の条件 </label><br>
                    <b-row v-for="(key, v) in other_conditions" :key="key">
                      <b-col cols='6' class='pr-4 border-table'>
                        <p>{{ v }}</p>
                      </b-col>
                      <b-col cols='6' class='pr-4 border-table'>
                        <p>{{ key }}</p>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>

                <b-col v-if="recruits.length == 0" sm="12" cols="6" class='ml-auto text-right pt-5'>
                  <b-button pill block  :href="'/jobs/' + jobInfo.id + '/application'" class='orange-button py-2'>この企業に応募する</b-button>
                </b-col>
                <b-col v-else cols="12" class='text-center pt-5'>
                    <p>この求人にはすでに申し込んでいます</p>
                </b-col>
                <b-col cols='6' sm="12" class='mr-auto pt-5'>
                  <b-button v-if="!isFavorite" @click="onPostFavorite" pill block class='gray-button2 py-2'> お気に入り登録する </b-button>
                  <b-button v-else pill block  @click="onDestroyFavorite" class='gray-button2 py-2'> お気に入りからはずす </b-button>
                </b-col>
              </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  components: {
  },
  data () {
    return {
      jobInfo: {},
      companyInfo: {},
      idToken: localStorage.idToken,
      id: this.$route.params.job_id,
      emStatusOptions: {
        full: this.$i18n.t('message.full_time_employee'),
        part: this.$i18n.t('message.part_time_job'),
        temporary: this.$i18n.t('message.temporary_staff'),
        contract: this.$i18n.t('message.contract_employee')
      },
      publicOptions: {
        public: this.$i18n.t('message.public'),
        private: this.$i18n.t('message.private')
      },
      salaryOptions: {
        'hourt': '時給' ,
        'week': '週給',
        'month': '月給' ,
        'year': '年収' ,
      },
      recruits: [],
      isFavorite: false,
      favorite: {},
      other_conditions: {},
      is_other_conditions: false

    }
  },
  methods: {
    split(str) {
      if(str != null) {
        return str.split(",")
      } else {
        return []
      }
    },
    fetch_job: function() {
      axios
      .get(process.env.VUE_APP_API + "/api/seeker/jobs/" + this.id ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.jobInfo = response.data.job
        this.recruits = response.data.recruit

        if(this.jobInfo.other_conditions != null) {
          this.other_conditions = JSON.parse(this.jobInfo.other_conditions)
          this.is_other_conditions = true
        }

        this.favorite = response.data.favorite
        if(this.favorite == null) {
          this.isFavorite = false
        } else {
          this.isFavorite = true
        }
      }).catch(error => {
        console.log('this is error', error)
      })
    },
    onDestroyFavorite() {
      axios
        .delete(process.env.VUE_APP_API + "/api/seeker/favorite_jobs/" + this.favorite.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.isFavorite = false
        }).catch(error => {
          console.log('this is org error', error)
        })
    },
    onPostFavorite() {
      axios
        .post(process.env.VUE_APP_API + "/api/seeker/favorite_jobs", {favorite_job: {job_id: this.jobInfo.id, organization_id: this.jobInfo.organization_id}}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.isFavorite = true
        }).catch(error => {
          console.log('this is org error', error)
        })
    },
    sendApplication: function() {
      this.$swal.fire({
        title: '申し込みをしますか？',
        text: "申し込みをし、企業が承認を押すとマッチングされチャットが始まります。",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '申し込む'
      }).then((result) => {
        if(result.isConfirmed) {
          var r = {
            organization_id: this.jobInfo.organization_id, 
            job_id: this.jobInfo.id
          }
          axios
            .post(process.env.VUE_APP_API + "/api/seeker/recruits", {recruit: r}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
            .then(res => {
              console.log(res)
            }).catch(error => {
              console.log('this is error', error)
            })

        }
      })
    }
  },
  async mounted() {
    if( this.memberInfo.status == 'associate_member'){
      this.$router.push('./createUser')
    }else{
      if (this.memberInfo.status == "no_deposite_member") {
        //this.$router.push('./payment')
      }
    }
    this.fetch_job()
    this.$store.commit('setLoading', false)
  },

  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language
    }),
  }
}
</script>

<style scoped lang="scss">
.thread-title{
  font-size: 1.3rem;
}
.black{
  color: #000000;
}
.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}
.thread-date {
  font-size: 0.9rem;
}
.w100 {
  width: 100%;
}
.border-table {
  border: 1px solid #555;
}
@media (max-width: 991.98px) {
  .p-5 {
     padding-left: 20px !important;
     padding-right: 20px !important;
  }
  .orange-button {
     width: 100%;
  }
  .gray-button2 {
     width: 100%;
  }
}
</style>
